module.exports = __webpack_public_path__ + "static/media/icon_similarity.0e5c903f.png";